module.exports = __webpack_public_path__ + "static/media/selected.91240157.svg";